document.addEventListener('DOMContentLoaded', () => {
  const page = document.querySelector('[data-qa-page]');
  if (!page) return;

  const select = page.querySelector('#qa-category-select');
  const links = [...page.querySelectorAll('.pcs-qa__category-list a')];
  const sections = [...page.querySelectorAll('.pcs-qa__category')];

  select?.addEventListener('change', (event) => {
    document.querySelector(event.currentTarget.value)?.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start',
    });
  });

  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      const activeEntry = entries.find((entry) => entry.isIntersecting);
      if (!activeEntry) return;

      const activeHash = `#${activeEntry.target.id}`;
      links.forEach((link) => link.toggleAttribute('aria-current', link.hash === activeHash));
      if (select) select.value = activeHash;
    },
    { rootMargin: '-20% 0px -65% 0px', threshold: 0 }
  );

  sections.forEach((section) => observer.observe(section));
});
